import ButtonSlideMenu from "./ButtonSlideMenu";
import { GALLERY_TITLE } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { Album } from "../../assets/svg/MenuIcons";
import useOutsideCampaignGallery from "../../hooks/useOutsideCampaignGallery";

const ButtonOpenGallery = () => {
  const { t } = useTranslationApp();
  const { onOpenGallery, galleryModal } = useOutsideCampaignGallery();

  return (
    <>
      <ButtonSlideMenu
        id="button-open-gallery"
        startIcon={<Album className="w-5 h-5" />}
        onClick={onOpenGallery}
      >
        {t(GALLERY_TITLE)}
      </ButtonSlideMenu>
      {galleryModal}
    </>
  );
};

export default ButtonOpenGallery;
